export const DAYS_UNTIL_DISPLAYED_AGAIN = 30;
